import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'ORGANIZATION_CREATION_PAGE.title',
    defaultMessage: 'Create client',
  },
  create: {
    id: 'ORGANIZATION_CREATION_PAGE.create',
    defaultMessage: 'Create',
  },
});



// WEBPACK FOOTER //
// ./components/pages/OrganizationCreationPage/messages.js